<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：统计-会员统计-新增会员
      -->
  <div class="ww100 mt30">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="新增会员" name="new"></el-tab-pane>
      <el-tab-pane label="成交会员数" name="pay"></el-tab-pane>
    </el-tabs>

      <div class="d-b-c" style="margin-bottom: 15px;">
      <div>
        <el-date-picker size="small" v-model="datePicker" type="daterange" align="right" unlink-panels format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          @change="changeDate" :picker-options="pickerOptions"></el-date-picker>
      </div>
    </div>
  
      <el-select size="small" v-model="tuiguang_id" placeholder="请选择" v-if="homeshow">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="(item, index) in shlist2" :key="index" :label="item.user_name"
          :value="item.shop_user_id"></el-option>
      </el-select>

      <el-button size="small" type="primary" icon="el-icon-search"
          @click="onSubmit2" v-if="homeshow">查询
      </el-button>
      
    <div class="">
      <div class="Echarts">
        <div id="LineChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthApi from '@/api/auth.js';
import IndexApi from "@/api/index.js";
import StatisticsApi from '@/api/statistics.js';
import OrderApi from "@/api/order.js";
import { formatDate } from '@/utils/DateTime.js';
export default {
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    return {
      homeshow:true,
      roleList:"",
      tuiguang_id: "",
      shlist2: [],
      /*是否正在加载*/
      loading: true,
      /*类别*/
      activeName: 'new',
      /*时间快捷选项*/
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      datePicker: [formatDate(startDate, 'yyyy-MM-dd'), formatDate(endDate, 'yyyy-MM-dd')],
      /*数据对象*/
      dataList: null,
      /*交易统计图表对象*/
      myChart: null,
      /*图表数据*/
      option: {
        title: {
          //text: 'ECharts 入门示例'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {}
      }
    };
  },
  inject: ['baseInfo'],
  created() {

  },
  mounted() {
    this.myEcharts();
    this.getTableList();
    this.gofenpei();
  },
  methods: {
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      AuthApi.userList(Params, true)
        .then(data => {
          self.roleList = data.data.list.data;
          // console.log("roleList",self.roleList);
          // console.log("baseInfo",self.baseInfo.user.user_name);
          let datainfo = self.roleList;
          for (let item of datainfo) {
            // console.log(item.user_name);
            if (item.user_name == self.baseInfo.user.user_name) {
              // console.log(item.role_id);
              if(item.role_id == 4){
                  self.homeshow = false;
              }else{
                self.homeshow = true
              }
            }
          }
        })
        .catch(error => {});
    },
    onSubmit2(){
      this.getData();
    },

    gofenpei() {
      OrderApi.authuser({
        role_id: 4
      }, true).then(data => {
        this.shlist2 = data.data.list.data;
      })
    },

    /*切换*/
    handleClick(e) {
      this.getData();
    },

    /*选择时间*/
    changeDate() {
      this.getData();
    },

    /*创建图表对象*/
    myEcharts() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('LineChart'));
      /*获取列表*/
      this.getData();
    },

    /*格式数据*/
    createOption() {
      if (!this.loading) {
        let names = [];
        let xAxis = this.dataList.days;
        let series1 = [];
        this.dataList.data.forEach(item => {
          series1.push(item.total_num);
        });
        if (this.activeName == 'new') {
          names = ['新增会员数'];
        } else if (this.activeName == 'refund') {
          names = ['成交会员数'];
        }

        // 指定图表的配置项和数据
        this.option.xAxis = {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        };
        this.option.color = ["red", "#409EFF"];

        this.option.legend = {
          data: [{ name: names[0], color: '#ccc' }]
        };
        this.option.series = [
          {
            name: names[0],
            type: 'line',
            data: series1,
            lineStyle: {
              color: 'red'
            }
          }
        ];

        this.myChart.setOption(this.option);
        this.myChart.resize();
      }
    },

    /*获取列表*/
    getData() {
      let self = this;
      self.loading = true;

      let UserApi = null;

      if (self.activeName == 'new') {
        UserApi = StatisticsApi.getNewUser2;
      }

      if (self.activeName == 'pay') {
        UserApi = StatisticsApi.getPayUser2;
      }

      console.log(self.baseInfo.user.shop_user_id);



      let datainfo = {};
      datainfo.search_time = self.datePicker;

      if(self.baseInfo.user.shop_user_id == 10001 || this.baseInfo.user.shop_user_id == 10009 || this.baseInfo.user.shop_user_id ==  10010){
        datainfo.tuiguang_id = self.tuiguang_id;
        console.log(datainfo);
      }



      UserApi(
        datainfo,
        true
      )
        .then(res => {
          self.dataList = res.data;
          self.loading = false;
          self.createOption();
        })
        .catch(error => { });
    }
  }
};
</script>

<style scoped="scoped">
.Echarts {
  box-sizing: border-box;
}

.Echarts>div {
  width: 100%;
  height: 360px;
  box-sizing: border-box;
}</style>



// WEBPACK FOOTER //
// src/views/statistics/user/part2/LineChart.vue